export function ParseErrorsList({ errors }: { errors: Record<string, string> }) {
  const entries = Object.entries(errors);

  return (
    <div className="px-4 font-mono">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b-2 border-gray-300">
            <th className="text-left text-sm font-semibold text-gray-900 px-1 py-2 w-1/3">File</th>
            <th className="text-left text-sm font-semibold text-gray-900 px-1 py-2">Reason</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {entries.map(([filename, err]) => (
            <tr key={filename}>
              <td className="px-1 py-1 text-xs text-gray-700 align-top break-all">{filename}</td>
              <td className="px-1 py-1 text-xs text-gray-700 align-top">{err}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
